var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02-car"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linear_color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485,287l-93.5-40.9l-56-68.9c-6.8-8.4-17.1-13.3-27.9-13.3H83.8c-16.7-0.1-31.9,9.4-39.4,24.3L8.6,259.9 C5.6,266,4,272.7,4,279.5V376c0,19.9,16.1,36,36,36h13.2c6.6,32.5,38.3,53.4,70.8,46.8c23.6-4.8,42-23.2,46.8-46.8h186.4 c6.6,32.5,38.3,53.4,70.8,46.8c23.6-4.8,42.1-23.3,46.8-46.9c18.7-1.5,33.2-17.1,33.2-35.9v-55.4C508,305.8,498.8,292.4,485,287z  M316.9,192.4l41.9,51.6H268v-56h39.6C311.2,188,314.6,189.6,316.9,192.4z M196,188v56H94.1l26.9-56H196z M65.9,199.1 c3.4-6.8,10.3-11.1,17.9-11.1h10.6l-26.9,56h-24L65.9,199.1z M112,436c-19.9,0-36-16.1-36-36s16.1-36,36-36s36,16.1,36,36 C148,419.9,131.9,436,112,436z M416,436c-19.9,0-36-16.1-36-36s16.1-36,36-36s36,16.1,36,36C452,419.9,435.9,436,416,436z  M484,376c0,5.6-3.9,10.4-9.3,11.7c-6.8-32.4-38.6-53.2-71-46.4c-23.4,4.9-41.7,23.3-46.5,46.7H170.8 c-6.6-32.5-38.3-53.4-70.8-46.8C76.4,346,58,364.4,53.2,388H40c-6.6,0-12-5.4-12-12v-96.5c0-3.1,0.7-6.2,2.1-8.9l1.3-2.6H208 c6.6,0,12-5.4,12-12v-68h24v68c0,6.6,5.4,12,12,12h125.5l94.1,41.2c0.2,0.1,0.4,0.2,0.6,0.2c4.7,1.8,7.8,6.2,7.8,11.2V376z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 400,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416,
    cy: 400,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,292h-15c-6.6,0-12,5.4-12,12s5.4,12,12,12h15c6.6,0,12-5.4,12-12S278.6,292,272,292z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,292h-24c-6.6,0-12,5.4-12,12s5.4,12,12,12h24c6.6,0,12-5.4,12-12S134.6,292,128,292z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.3ab502a11625e17fb90655fd8f994296.svg";
export { ForwardRef as ReactComponent };